<template>
  <div>
    <v-toolbar
      color="primary"
      fixed
      dark
      app
      dense
      clipped-left
      clipped-right
    >
      <v-toolbar-side-icon @click.stop="handleDrawerToggle" />
      <v-toolbar-title class="ml-3 pl-0">
        <select-store />
      </v-toolbar-title>

      <v-spacer />

      <language-switcher
        flag-only
        flag-size="24px"
      />

      <v-tooltip bottom>
        <v-btn
          slot="activator"
          :to="{name: 'settings'}"
          icon
        >
          <v-icon>tune</v-icon>
        </v-btn>
        <span>{{ $t('Store Settings') }}</span>
      </v-tooltip>

      <v-btn
        icon
        @click.stop="$radio.$emit('toggle-dark')"
      >
        <v-icon v-if="this.$vuetify.dark">wb_sunny</v-icon>
        <v-icon v-else>brightness_3</v-icon>
      </v-btn>

      <v-tooltip
        v-if="false"
        bottom>
        <v-btn
          slot="activator"
          icon
          @click.stop="rightDrawer = !rightDrawer"
        >
          <v-icon>notifications</v-icon>
        </v-btn>
        <span>{{ $t('{0} unread notifications', [notifications.unread]) }}</span>
      </v-tooltip>

      <v-menu
        :nudge-bottom="10"
        offset-y
        origin="center center"
        transition="scale-transition"
      >
        <v-btn
          slot="activator"
          icon
          large
          flat
        >
          <v-avatar
            class="while"
            size="30px"
          >
            <span>{{ adminInitials }}</span>
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile
            :to="{name: 'my-account'}"
            ripple="ripple"
            rel="noopener"
          >
            <v-list-tile-action>
              <v-icon>perm_identity</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('My Account') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            ripple="ripple"
            rel="noopener"
            @click="logout"
          >
            <v-list-tile-action>
              <v-icon>fullscreen_exit</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('Logout') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
  </div>
</template>

<script>
import SelectStore from './StoreSelect'
import LanguageSwitcher from './LanguageSwitcher'
import { mapGetters } from 'vuex'

export default {
  name: 'AppToolbar',

  components: {
    SelectStore,
    LanguageSwitcher
  },

  data () {
    return {
      date: {
        from: new Date().toISOString().substr(0, 10),
        to: new Date().toISOString().substr(0, 10)
      },
      menu: false,
      menu2: false,
      notifications: {
        unread: 5
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/me'
    }),

    adminInitials () {
      const name = this.user.name || 'Admin User'
      const fullName = name.split(' ')
      const initials = name.split(' ').shift().charAt(0) + fullName.pop().charAt(0)
      return initials.toUpperCase()
    }
  },

  methods: {
    logout () {
      this.$store
        .dispatch('auth/AUTH_LOGOUT')
        .then(() => {
          this.$radio.$emit('app-logout')
          this.$toast(this.$t('Logout successfully.'))
        })
    },

    handleDrawerToggle () {
      this.$radio.$emit('app-drawer-toggled')
    }
  }
}
</script>
